<template>
  <el-dialog :append-to-body="true" :close-on-click-modal="false" id="reset-password-layer" title="修改用户名"
    :visible.sync="dialogVisible" width="530px">
    <div class="reset-phone">
      已绑定手机号 <span>{{ phone }}</span>
    </div>
    <el-form @submit.native.prevent :model="resetForm" :rules="resetRules" ref="resetForm" label-width="0"
      class="reset-Form">
      <el-form-item prop="smgcode">
        <el-input placeholder="请输入短信验证码" maxlength="6" size="small" v-model="resetForm.smgcode"
          oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        <div class="code-btn">
          <el-button class="right-btn" size="small" type="primary" plain :disabled="!sendAuthCode" @click="getMsgAuthCode"
            v-show="sendAuthCode">获取验证码</el-button>
          <el-button type="primary" size="small" plain v-show="!sendAuthCode" class="right-btn">
            {{ auth_time }}秒</el-button>
        </div>
      </el-form-item>

      <el-form-item prop="userName">
        <el-input size="small" placeholder="用户名由5~25位的字母和数字组成" v-model="resetForm.userName" maxlength="25"></el-input>
      </el-form-item>
    </el-form>
    <div class="reset-phone">
    </div>
    <div class="dialog-btns">
      <el-button type="primary" size="small" @click="submitHandle" class="btn-ok">确认</el-button>
      <el-button plain size="small" @click="cancel" class="btn-cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from "vuex";
import { getSmsVerificationCode } from "@/api/common";
import { changeUserNumber } from "@/api/account/account";

// 校验用户名
var checkUserName = (rule, value, callback) => {
  // var userNameReg= /^[a-zA-Z][a-zA-Z0-9_]{5,13}$/;
  var regPureNumber = /^[0-9]{5,25}$/
  var userNameReg = /^[a-zA-Z0-9]{5,25}$/;
  var regPureLetter = /^[a-zA-Z]{5,25}$/
  // var reg2 = /^_{5,25}$/

  if (!userNameReg.test(value)) {
    callback(new Error('用户名格式不正确！仅允许5-25位字母数字组成!'));
  }

  if (regPureNumber.test(value)) {
    callback(new Error('用户名格式不正确！不能是纯数字！'));
  }

  if (regPureLetter.test(value)) {
    callback(new Error('用户名格式不正确！不能是纯字母！'));
  } else {
    callback();
  }
}

export default {
  data() {
    return {
      dialogVisible: false,
      resetForm: {
        smgcode: "",
        userName: ""
      },
      resetRules: {
        smgcode: [
          { required: true, message: "请输入短信验证码", trigger: "change" },
        ],
        userName: [
          {
            required: true,
            message: '请输入新用户名',
            trigger: 'blur'
          },
          { validator: checkUserName, trigger: 'blur' }
        ]
      },
      auth_time: 60,
      sendAuthCode: true,
    };
  },
  computed: {
    phone() {
      var str1 = "";
      if (this.userInfo.phone) {
        str1 = this.userInfo.phone.replace(
          /(\d{3})(\d+)(\d{4})/,
          function (x, y, z, p) {
            var i = "";
            while (i.length < z.length) {
              i += "*";
            }
            return y + i + p;
          }
        );
        return str1;
      }
    },
    ...mapState(["userInfo"]),
  },
  methods: {
    getMsgAuthCode() {
      this.sendAuthCode = false;
      getSmsVerificationCode({
        bizType: "changeUserNumber",
      })
        .then((res) => {
          if (res.code != "200") {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
            this.sendAuthCode = true;
            this.auth_time = 60;
          } else {
            this.$message({
              message: "短信发送成功",
              type: "success",
            });
            // 倒计时

            this.auth_time = 60;
            var auth_timetimer = setInterval(() => {
              this.auth_time--;
              if (this.auth_time <= 0) {
                this.sendAuthCode = true;
                clearInterval(auth_timetimer);
              }
            }, 1000);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error('服务器错误！');
        });
    },
    submitHandle() {
      this.$refs["resetForm"].validate((valid) => {
        if (valid) {
          changeUserNumber({
            vcode: this.resetForm.smgcode,
            userName: this.resetForm.userName,
          }).then((res) => {
            if (res.code != 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "warning",
              });
            } else {
              this.$message({
                showClose: true,
                message: "用户名修改成功，请重新登录！",
                type: "success",
              });

              setTimeout(() => {
                this.cancel();
                this.logout();
              }, 1000);
            }
          });
        } else {
          return false;
        }
      });
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    cancel() {
      this.dialogVisible = false;
      this.$refs["resetForm"].resetFields();
      this.resetForm.smgcode = "";
      this.resetForm.userName = "";
      this.sendAuthCode = true;
      this.auth_time = 60;
    },
  },
};
</script>
<style>
/* .reset-Form input,
.reset-Form button {
  height: 48px;
} */
</style>
<style scoped>
.reset-phone {
  /* font-size: 14px;
  color: #333333; */
  /* width: 400px; */
  margin: 0 auto 22px;
}

.code-btn {
  position: absolute;
  right: 0;
  top: 0;
}

.reset-Form {
  /* width: 400px; */
  margin: 0 auto;
}

.dialog-btns {
  /* width: 400px; */
  /* margin: 40px auto 0; */
  /* display: flex;
    justify-content: space-between; */
  /* overflow: hidden; */
}

.dialog-btns button {
  /* display: block;
  width: 140px;
  height: 40px;
  font-size: 14px;
  border-radius: 6px;
  float: left; */
}

.right-btn {
  border-radius: 0 4px 4px 0;
}
</style>
